{
  "registered": "Registrerad",
  "pending approval": "Väntar på godkännande",
  "not approved": "Ej godkänd",
  "approved": "Godkänd",
  "cancelled": "Avbruten",
  "out of stock": "Ej i lager"
}
